var viewport = (function() {
	var w = window,
		d = document,
		e = d.documentElement,
		g = d.getElementsByTagName("body")[0],
		x = e.clientWidth || w.innerWidth || g.clientWidth,
		y = e.clientHeight || w.innerHeight || g.clientHeight;
	return { width: x, height: y };
})();
export default viewport;

export function scrollTop() {
	var scrollTop = 0,
		bodyScrollTop = 0,
		documentScrollTop = 0;
	if (document.body) {
		bodyScrollTop = document.body.scrollTop;
	}
	if (document.documentElement) {
		documentScrollTop = document.documentElement.scrollTop;
	}
	scrollTop = bodyScrollTop - documentScrollTop > 0 ? bodyScrollTop : documentScrollTop;
	return scrollTop;
}

export function scrollHeight() {
	var scrollHeight = 0,
		bodyScrollHeight = 0,
		documentScrollHeight = 0;
	if (document.body) {
		bodyScrollHeight = document.body.scrollHeight;
	}
	if (document.documentElement) {
		documentScrollHeight = document.documentElement.scrollHeight;
	}
	scrollHeight =
		bodyScrollHeight - documentScrollHeight > 0 ? bodyScrollHeight : documentScrollHeight;
	return scrollHeight;
}

export function windowHeight() {
	var windowHeight = 0;
	if (document.compatMode == "CSS1Compat") {
		windowHeight = document.documentElement.clientHeight;
	} else {
		windowHeight = document.body.clientHeight;
	}
	return windowHeight;
}
